<template>
  <!-- 年度分析报告 -->
  <div class="paginations">
    <div class="table-search-box table-search-box-header">
      <el-form :inline="true" :model="searchData" class="demo-form-inline">
        <el-form-item label="年份：">
          <el-select size="small" v-model="searchData.name" placeholder="请选择年份" :popper-append-to-body="false">
            <el-option v-for="(item,index) in monitorTimeList" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div class="search_button">
            <i class="pointer el-icon-search" @click="search()"></i>
            <i class="pointer el-icon-refresh-left" @click="resetting"></i>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="table_box">
      <el-table :data="tableObj.list" style="width: 100%">
        <el-table-column type="index" label="序号" align='center' width="120">
        </el-table-column>
        <el-table-column prop="yearOrMonth" label="年度" align='center'>
        </el-table-column>
        <el-table-column label="上半年分析报告" align='center'>
          <template slot-scope="scope">
            <span v-if="scope.row.halfYearReportFilePath">
              <i class="icona icon-details" title="查看上半年分析报告" @click="see(scope.row.halfYearReportFilePath)"></i>
              <i class="icona icon-download" title="下载上半年分析报告" @click="download(scope.row.halfYearReportFilePath)"></i>
            </span>
            <span v-else>——</span>
          </template>
        </el-table-column>

        <el-table-column label="年度分析报告" align='center'>
          <template slot-scope="scope">
            <span v-if="scope.row.yearReportFilePath">
              <i class="icona icon-details" title="查看年度报告" @click="see(scope.row.yearReportFilePath)"></i>
              <i class="icona icon-download" title="下载年度报告" @click="download(scope.row.yearReportFilePath)"></i>
            </span>
            <span v-else>——</span>
          </template>
        </el-table-column>
        <el-table-column label="年度个性化报告" align='center'>
          <template slot-scope="scope">
            <span v-if="scope.row.personYearReportFilePath">
              <i class="icona icon-details" title="查看年度个性化报告" @click="see(scope.row.personYearReportFilePath)"></i>
              <i class="icona icon-download" title="下载年度个性化报告" @click="download(scope.row.personYearReportFilePath)"></i>
            </span>
            <span v-else>——</span>
          </template>
        </el-table-column>

        <el-table-column label="年度基本报告" align='center'>
          <template slot-scope="scope">
            <span v-if="scope.$index == 0">
              <i class="icona icon-details" title="查看年度基本报告" @click="seeBasic"></i>
              <!-- <i class="icona icon-download" title="下载年度基本报告"  @click="download(scope.row.personYearReportFilePath)"></i> -->
            </span>
            <span v-else>——</span>
          </template>
        </el-table-column>
      </el-table>

      <pageNumber :paginations="7" :pageNum="searchData.pageDto.pageNum" :pageSize="searchData.pageDto.pageSize" :total="tableObj.total" :jumpTo="tableObj.jumpTo" @currentChange="search"></pageNumber>
    </div>
  </div>
</template>

<script>
import pageNumber from '@/components/pageNumber.vue' //分页

export default {
  components: {
    pageNumber
  },
  data() {
    return {
      searchData: {
        monthStr: '',
        name: '',
        pageDto: {
          pageNum: 1,//当前显示的页面页码数
          pageSize: 10, //一页多少条数据
        },
        type: ''
      },



      tableObj: {
        total: 0,
        jumpTo: 1,
        list: []
      },
      monitorTimeList: []
    }
  },
  created() {
    this.search()
    var year = new Date().getFullYear() - 2017 + 1
    for (let i = 0; i < year; i++) {
      this.monitorTimeList.push((2017 + i))
    }
  },
  methods: {
    // 获取表格数据
    search(type) {
      this.searchData.pageDto.pageNum = type ? type : 1
      this.tableObj.jumpTo = type ? type : 1
      this.$axios.post(this.$apiurls.report_yaer_Monthly_getYearOrPensonYearReportList, this.searchData, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.tableObj.list = res.data.list
          this.tableObj.total = res.data.total
        }
      });
    },
    // 重置
    resetting() {
      this.searchData.name = ''
      this.search('')
    },
    // 查看
    see(url) {
      window.open(url)
    },
    // 下载
    download(url) {
      window.open(`${this.$apiurls.report_yaer_Monthly_downloadReportFile}?filePath=${url}`)
    },
    // 在线查看年度基本报告
    seeBasic() {
      const news = this.$router.resolve({ name: '/basicReportTable' })
      window.open(`${news.location.name}`, '_blank')
    }
  }
}
</script>

<style  lang="scss" src="@/assets/css/popUp.scss" scoped></style>
<style  lang="scss" src="@/assets/css/tableList.scss" scoped></style>
<style lang="scss" scoped>
.paginations {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

.table-search-box-header {
  height: 40px;
  margin-bottom: 20px;
}
</style>
